<script>
import OrdersApi from "@/services/orders-api";
import Order from "@/components/orderComponent"

export default {
    components: {
        Order
    },
    props: {
        orderId: {
            type: Number,
            default: 0,
        },

  },
    mounted(){
    this.role=sessionStorage.getItem("userr");
    this.getCustomerDeliveryAddresses()
 
  },
  data (){
      return{
          optionsDeliveryAddresses: [],
          selectedDeliveryAddress: null,
          orderMessage: '',
          isSubmittingOrder:false,


      }
  },
  methods:{

    getCustomerDeliveryAddresses(){
      OrdersApi.getCustomerDeliveryAddresses().then(
        (result)=>{
          if(result){
            this.optionsDeliveryAddresses=result
            if(this.optionsDeliveryAddresses.length){
              this.selectedDeliveryAddress=this.optionsDeliveryAddresses[0]
            }
          }

        }
      )
    },


      submitOrder() {
      this.isSubmittingOrder = true;
      OrdersApi.submitOrder(this.orderId, this.orderMessage, 
      this.selectedPriority==null ? null : this.selectedPriority.value, 
      this.selectedDeliveryAddress==null ? null : this.selectedDeliveryAddress.id,
      false,this.desiredDeliveryDate,this.promotionCode)
      .then(isSubmitted => {
            if(isSubmitted) {
              this.isSubmittingOrder = false;
              this.$emit('update', true)
            }
        })
      .finally(() => {
        this.isSubmittingOrder = false; 
      })
    },

  }
}
</script>
<template>
<div>
    <div class="row p-4 d-print-none">
        <div class="col-12">
          <form class="form-horizontal" role="form">
            <!-- Adresse de Livraison -->
            <div class="form-group row">
              <label class="col-md-2 col-form-label font-size-14">{{$t('ordersDetailsModal.body.address.label')}}</label>
              <div class="col-md-10">
                <v-select class="pb-2 font-size-16"   :options="optionsDeliveryAddresses" v-model="selectedDeliveryAddress" :placeholder="$t('ordersDetailsModal.body.address.placeholder')" label="address" >
                    <span slot="no-options">{{$t("lists.emptyLists.label")}}</span>
                </v-select> 
              </div>
            </div>       
            <div class="form-group row mb-0">
              <label class="col-md-2 col-form-label font-size-14">{{$t('ordersDetailsModal.body.message.label')}}</label>
              <div class="col-md-10">
                  <!-- Editor -->
                  <textarea
                    v-model="orderMessage"
                    class="form-control"
                    :maxlength="255"
                    rows="3"
                    :placeholder="$t('ordersDetailsModal.body.message.placeholder')"
                  ></textarea>
                  <div class="text-center">
                    <p
                      v-if="orderMessage"
                      class="badge position-absolute"
                      :class="{ 'badge-success': orderMessage.length !== 255,
                                'badge-danger': orderMessage.length === 255 }"
                    >
                      {{ orderMessage.length }} /
                      255
                    </p>
                  </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <Order :orderId= this.orderId :isCatalogList=true  :deliveryAddress="selectedDeliveryAddress==null ? null : selectedDeliveryAddress.address" :deliveryMode="selectedDeliveryAddress==null ? null : selectedDeliveryAddress.deliveryMode" /> 

      <div class="row p-4 d-print-none" >
          <div class="col-md-4 col-sm-12 "/>
          <div class="col-md-4 col-sm-12 "/>
          <div class="col-md-4 col-sm-12 d-print-none pr-0 ">
              <b-button variant="danger" style="width:100%" size="lg" @click="submitOrder()" :disabled="isSubmittingOrder" >
                  <i class="fas fa-paper-plane font-size-18 align-middle mr-2"></i> <span class="font-weight-bold font-size-14">{{$t('ordersDetailsModal.submitOrder')}} </span>
              </b-button>
          </div>
      </div> 
</div>
</template>